var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "Polaris-LegacyCard" },
      [
        _vm._m(0),
        _c("div", { staticClass: "Polaris-LegacyCard__Section" }, [
          _c("div", { staticClass: "flex text-gray-500 items-center" }, [
            _c("span", {}, [
              _vm._v(
                _vm._s(_vm.completedValue.completedFeatures) +
                  " of " +
                  _vm._s(_vm.completedValue.totalFeatures) +
                  " tasks complete"
              )
            ]),
            _c("div", { staticClass: "flex-1 ml-4" }, [
              _c(
                "div",
                {
                  staticClass:
                    "Polaris-ProgressBar Polaris-ProgressBar--sizeSmall Polaris-ProgressBar--toneHighlight"
                },
                [
                  _c("progress", {
                    staticClass: "Polaris-ProgressBar__Progress",
                    attrs: { value: "40", max: "100" }
                  }),
                  _c(
                    "div",
                    {
                      staticClass:
                        "Polaris-ProgressBar__Indicator Polaris-ProgressBar__IndicatorAppearDone",
                      staticStyle: { "--pc-progress-bar-duration": "500ms" },
                      style: {
                        "--pc-progress-bar-percent":
                          _vm.completedValue.percentage
                      }
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "Polaris-ProgressBar__Label" },
                        [
                          _vm._v(_vm._s(_vm.completedValue.percentage)),
                          _vm._v("%")
                        ]
                      )
                    ]
                  )
                ]
              )
            ])
          ])
        ]),
        _vm._l(_vm.features, function(feature, index) {
          return _c(
            "div",
            { key: index, staticClass: "Polaris-LegacyCard__Section" },
            [
              _c("div", { staticClass: "flex justify-between" }, [
                _c("div", {}, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "Polaris-LegacyStack Polaris-LegacyStack--alignmentCenter Polaris-LegacyStack--noWrap_vecks"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "Polaris-LegacyStack__Item Polaris-LegacyStack__Item--fill"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "Polaris-LegacyStack Polaris-LegacyStack--vertical Polaris-LegacyStack--spacingExtraTight"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "Polaris-LegacyStack__Item" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "Polaris-Text--root Polaris-Text--bodyMd Polaris-Text--semibold flex"
                                    },
                                    [
                                      _vm._v(_vm._s(feature.label) + " "),
                                      _vm.onboardingFlags &&
                                      _vm.onboardingFlags[feature.flag]
                                        ? _c(
                                            "svg",
                                            {
                                              staticClass:
                                                "h-6 w-6 text-indigo-600 group-hover:text-indigo-800",
                                              attrs: {
                                                xmlns:
                                                  "http://www.w3.org/2000/svg",
                                                viewBox: "0 0 20 20",
                                                fill: "currentColor",
                                                "aria-hidden": "true"
                                              }
                                            },
                                            [
                                              _c("path", {
                                                attrs: {
                                                  "fill-rule": "evenodd",
                                                  d:
                                                    "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
                                                  "clip-rule": "evenodd"
                                                }
                                              })
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "Polaris-LegacyStack__Item" },
                                [
                                  _c("p", [
                                    _vm._v(
                                      " " + _vm._s(feature.description) + " "
                                    )
                                  ])
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  )
                ]),
                _c("div", {}, [
                  _c(
                    "a",
                    {
                      staticClass: "Polaris-Button",
                      on: {
                        click: function($event) {
                          return _vm.gotoRoute(feature)
                        }
                      }
                    },
                    [_vm._m(1, true)]
                  )
                ])
              ])
            ]
          )
        })
      ],
      2
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "Polaris-LegacyCard__Header" }, [
      _c(
        "h2",
        {
          staticClass:
            "Polaris-Text--root Polaris-Text--bodyMd Polaris-Text--semibold flex"
        },
        [_vm._v(" Welcome to PushHike! ")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "Polaris-Button__Content" }, [
      _c("span", { staticClass: "Polaris-Button__Text" }, [_vm._v("Manage")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }